<div class="header-content" #headerContent>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="row">
          <div class="col-lg-3 col-6 left-content">
            <ng-content select="[headerLogo]"></ng-content>
          </div>
          <div class="col-lg-9 col-6 text-right right-content right-menu-content">
            <ng-content select="[navigationLink]"></ng-content>
            <div class="">
              <a class="py-s" style='color: #105cb0;font-weight: bold;vertical-align: bottom;'>
                {{userName}}
                <br>
                <span style='font-size:10px;'>{{roleName | uppercase}}</span>
              </a>
              <ul class="top-menus d-inline-block">
                <li class="dropdwon">
                  <a class="dropdown-toggle" (click)="toggleMenu()">
                    <img src='assets/images/user.png' class="toggleUserDropdown" #toggleDropdown alt='User'>
                  </a>
                  <ul class="dropdown-menus" #dropdownMenu *ngIf="isShowMenu">
                    <ng-content select="[headerMenu]"></ng-content>
                    <li>
                      <a (click)="showAppInfo(appInfoModal)" id="appInfo">
                        <img src='assets/images/about_icon.png' title='App-Info' class='appinfo-img'
                          alt='app-Info'>{{ headerConstant?.appInfo}}
                      </a>
                    </li>
                    <li *ngIf="isCognito">
                      <a (click)="openChangePassword()">
                        <img src="assets/images/profile/password.png"
                          alt="{{headerConstant?.changePassword}}">{{ headerConstant?.changePassword}}</a>
                    </li>
                    <li>
                      <a (click)="showLogoutModal(logoutModal)" id="logoutlink">
                        <img src='assets/images/profile/logout.png' title='Logout' class='logout-img'
                          alt='Logout'>{{ headerConstant?.logout}}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div>
              <a class="customLinks" (click)="sendSupportMail()"><i style="cursor: pointer;" class="fa fa-envelope-o" aria-hidden="true" title="Support Mail"></i></a>
            </div>
            <ng-container *ngIf="enableHelp">
              <div class="d-inline">
                <a (click)="docRedirect()" title="Help">
                  <img src="assets/images/help.png" alt="Help" class="bcone-help" />
                </a>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<ng-template #appInfoModal let-appInfoModal>
  <div class="modal-header">
    <h2 class="modal-title" id="modal-basic-title">
      <span class="modal-title">{{ headerConstant?.appInfo}}</span>
    </h2>
    <button type="button" class="close" aria-label="Close" (click)="appInfoModal.close('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ headerConstant?.appVersion }} - {{appVersion}}</p>
    <p>{{ headerConstant?.appSdkVersion }} - {{appSdkVersion}}</p>
  </div>
</ng-template>
<ng-template #logoutModal let-logoutModal>
  <div class="modal-header">
    <h2 class="modal-title" id="modal-basic-title">
      <span class="modal-title">{{ headerConstant?.logout}}</span>
    </h2>
    <button type="button" class="close" aria-label="Close" (click)="logoutModal.close('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h3>{{ headerConstant?.logoutConfirmation }}</h3>
    <div class="button-grp">
      <button class="btn btn-outline-dark " type="button"
        (click)="logoutModal.close('Cross click')">{{ headerConstant?.cancel }}</button>
      <button class="btn btn-primary" (click)='signOut()'>{{ headerConstant?.logout }}</button>
    </div>
  </div>
</ng-template>